import {
  EditContextProvider,
  SimpleForm,
  useEditController,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  DateInput,
  SaveButton,
  Title,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { AppDeleteButton } from "../../components/AppDeleteButton";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { dateOnlyProps } from "../../util/dateOnly";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  ROLE_TYPE_CHOICES,
  SPHERE_CHOICES,
  omitEmptyDates,
} from "./positionRoleMeta";

export const UserPositionRoleEdit = (props: any) => {
  const { id } = useParams();
  const [roleType, setRoleType] = useState("");
  const changeRoleType = (e: any) => {
    setRoleType(e.target.value);
  };
  const controller: any = useEditController({
    resource: "user-position-roles/crud",
    mutationMode: "pessimistic",
    id,
    transform: omitEmptyDates,
  });
  // Tipo gravado no registro → mostra os campos certos ao abrir a edição
  const recordRoleType = controller?.record?.roleType;
  useEffect(() => {
    if (recordRoleType) {
      setRoleType(recordRoleType);
    }
  }, [recordRoleType]);
  const isCommission = roleType === "COMISSAO_EXTERNA";
  return (
    <EditContextProvider value={controller}>
      <Title title="Cargos e Funções" />
      {/* toolbar={false}: Salvar/Remover no topo, junto do Ver */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Cargos e Funções"
          firstPath="/#/user-position-roles/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
          actions={
            <>
              <AppDeleteButton label="Remover" />
              <SaveButton label="Salvar" />
            </>
          }
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Cargo" />
          <CardContent>
            {/* Campos em grade (antes, um embaixo do outro, com o status
                esticado em 50% da tela e as datas espremidas à esquerda) */}
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12}>
                <TextInput
                  source="id"
                  label="ID"
                  fullWidth
                  helperText={false}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <SelectInput
                  source="roleType"
                  label="Tipo de Cargo"
                  fullWidth
                  helperText={false}
                  choices={ROLE_TYPE_CHOICES}
                  onChange={(e) => {
                    changeRoleType(e);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ReferenceInput
                  source="roleStatusId"
                  reference="user-role-status/crud"
                  perPage={50}
                >
                  <AutocompleteInput
                    label="Status do Cargo"
                    optionText="name"
                    optionValue="id"
                    isRequired
                    fullWidth
                    helperText={false}
                  />
                </ReferenceInput>
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label={
                    "Nome " + (isCommission ? "da Comissão" : "do Cargo")
                  }
                  required
                  fullWidth
                  helperText={
                    roleType === "DTE"
                      ? "(Chefe, Subchefe, Secretário...)"
                      : roleType === "CARGOS_FUNCOES"
                      ? "(Presidente, Diretor, Conselheiro(a)...)"
                      : isCommission
                      ? "Comissão XYZ"
                      : false
                  }
                />
              </Grid>

              {isCommission && (
                <>
                  <Grid item xs={12} md={6}>
                    <TextInput
                      source="secondaryRole"
                      label="Cargo (comissões externas)"
                      fullWidth
                      helperText={"Ex.: Titular"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SelectInput
                      source="sphere"
                      label="Esfera de Atuação"
                      fullWidth
                      required
                      helperText={"Ex.: Federal, Estadual, Municipal..."}
                      choices={SPHERE_CHOICES}
                    />
                  </Grid>
                </>
              )}
              {roleType === "DTE" && (
                <Grid item xs={12}>
                  <ReferenceInput
                    source="technicalDivisionId"
                    reference="technical-divisions/crud"
                  >
                    <AutocompleteInput
                      label="Divisão Técnica"
                      optionText="name"
                      optionValue="id"
                      fullWidth
                      helperText={false}
                    />
                  </ReferenceInput>
                </Grid>
              )}

              {!isCommission && (
                <Grid item xs={12} md={4}>
                  <TextInput
                    source="yearRange"
                    label="Período"
                    fullWidth
                    helperText={"Ex.: 2006/2012"}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={isCommission ? 6 : 4}>
                <DateInput
                  source="fromDate"
                  label="A partir de (data)"
                  {...dateOnlyProps}
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={isCommission ? 6 : 4}>
                <DateInput
                  source="toDate"
                  label="Até (data)"
                  {...dateOnlyProps}
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12}>
                <ReferenceArrayInput reference="users/crud" source="users">
                  <AutocompleteArrayInput
                    optionText="fullName"
                    optionValue="id"
                    label="Sócios"
                    filterToQuery={(searchText: string) => ({
                      mailName: searchText,
                    })}
                    helperText={
                      "Consulte pelo / nome / mail / cpf. É possível selecionar múltiplos."
                    }
                  />
                  {/* //TODO CREATION NOT WORKING */}
                  {/* //TODO NOT SELECTING EXISTING */}
                </ReferenceArrayInput>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
